import type { IOrganizationFeatureClientPortalNotification } from './OrganizationFeatureClientPortalNotification.interface';

export default class OrganizationFeatureClientPortalNotification
  implements IOrganizationFeatureClientPortalNotification {
  sms: boolean;
  email: boolean;
  smsContent: string;
  emailContent: string;
  interval: number;

  static build = (data: IOrganizationFeatureClientPortalNotification) =>
    new OrganizationFeatureClientPortalNotification(data);
  static blank = () => new OrganizationFeatureClientPortalNotification();

  /**
   * Constructor
   * @param {IOrganizationFeatureClientPortalNotification} data
   */
  constructor(data?: IOrganizationFeatureClientPortalNotification) {
    this.sms = data?.sms === true;
    this.email = data?.email === true;
    this.smsContent = data?.smsContent || undefined;
    this.emailContent = data?.emailContent || undefined;
    this.interval = parseInt(data?.number || 0, 10);
  }
}
